import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createDepartment = createAsyncThunk(
  "createDepartment",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `department/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Department successfully created!");
    history("/app/organization/department");
    return response.data;
  }
);

const departmentCreateSlice = createSlice({
  name: "departmentCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createDepartment.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createDepartment.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createDepartment.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default departmentCreateSlice.reducer;